import React from 'react'
import { Link, Text } from 'components/ds'

/**
 * Terms component for displaying legal agreement links
 *
 * Displays links to the Terms of Service and Privacy Policy that users
 * must agree to when creating an account. Links open in new tabs.
 *
 * @returns JSX element containing the terms and privacy policy links
 */
const Terms: () => React.ReactElement<'div'> = () => (
  <Text align="center" size="2" color="gray">
    By continuing, you agree to the{' '}
    <Link
      href="https://disco.ac/terms"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Service
    </Link>{' '}
    and{' '}
    <Link
      href="https://disco.ac/privacy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </Link>
    .
  </Text>
)

export default Terms
